
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("68qgh", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.b393cd0c.js.map
